import React from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'

export default function App(){
  const { pathname } = useLocation()
  const wide = pathname.startsWith('/metrics')
  return (
    <div>
      <nav className="nav">
        <div><Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>Timur's Den</Link></div>
        <div>
          <NavLink to="/" end className={({isActive}) => isActive ? 'active' : undefined}>Home</NavLink>
          <NavLink to="/about" className={({isActive}) => isActive ? 'active' : undefined}>About</NavLink>
          <NavLink to="/metrics" className={({isActive}) => isActive ? 'active' : undefined}>Metrics</NavLink>
        </div>
      </nav>
      <main className={`container fade${wide ? ' wide' : ''}`} key={pathname}>
        <Outlet />
      </main>
    </div>
  )
}
